import { Link } from "react-router-dom";
import iconInsta from './../assets/iconInsta.png';
import iconLinke from './../assets/iconLinke.png';

type Props = {}

function PrivacyPolicy({ }: Props) {
    return (
        <div className="flex my-20 mx-40 items-center">
            <div className="flex flex-col gap-4">
                <span className="font-bold text-neonGreen text-2xl">
                    Onxite Privacy Policy
                </span>
                <span className="font-bold text-white text-xl">
                    Effective Date: 01/01/25
                </span>
                <span className="font-bold text-white text-md">
                    Introduction
                </span>
                <span className="font-regular text-white text-md">
                    Thank you for your interest in using our event marketing data analytics platform. 
                    We know how important is your privacy and we are committed to protecting any personal information you choose to provide to us. 
                    Onxite is a data analytics platform to measure and report sponsored events. Onxite is an event marketing technology company that may track advertisements on the websites you visit. 
                    Onxite understands that your online privacy is important to you, just like your event marketing experiences. 
                    We created a Privacy Policy to let you know what information we collect on the <a target="_blank" href="https://www.onxite.com/" className="underline text-neonGreen">onxite.com</a> website.
                </span>
                <span className="font-regular text-white text-md">
                    This Privacy Policy outlines how we collect, use, and disclose information when you interact with our platform. 
                    By accessing or using our services, you consent to the practices described in this policy.
                </span>
                <span className="font-bold text-grayText text-lg">
                    1. Information We Collect
                </span>
                <span className="font-bold text-white text-md">
                    1.1 Personal Information
                </span>
                <span className="font-regular text-white text-md">
                    We may collect certain personal information from you when you use our platform. This may include:
                </span>
                <ul className="list-disc font-regular text-white text-md">
                    <li>Name, email address, and contact information</li>
                    <li>Company name and job title</li>
                    <li>Billing and payment details</li>
                    <li>User-generated content and preferences</li>
                </ul>
                <span className="font-bold text-white text-md">
                    1.2 Event Data
                </span>
                <span className="font-regular text-white text-md">
                    When you use our platform for event marketing analytics, we collect and process data related to the sponsored events. This may include:
                </span>
                <ul className="list-disc font-regular text-white text-md">
                    <li>Event details (e.g., event name, date, location)</li>
                    <li>Attendee demographics and engagement data</li>
                    <li>Event marketing and advertising metrics</li>
                    <li>Interactions with event websites or mobile applications</li>
                </ul>
                <span className="font-bold text-grayText text-lg">
                    2. How We Use Your Information
                </span>
                <span className="font-regular text-white text-md">
                    We use the collected information for various purposes, including:
                </span>
                <ul className="list-disc font-regular text-white text-md">
                    <li>Providing and improving our platform and services</li>
                    <li>Analyzing event marketing performance and generating reports</li>
                    <li>Personalizing and optimizing user experiences</li>
                    <li>Communicating with you about our services and updates</li>
                    <li>Processing payments and managing billing inquiries</li>
                    <li>Ensuring the security and integrity of our platform</li>
                </ul>
                <span className="font-bold text-grayText text-lg">
                    3. Information Sharing and Disclosure
                </span>
                <span className="font-bold text-white text-md">
                    3.1 Service Providers
                </span>
                <span className="font-regular text-white text-md">
                    We may share your personal information with trusted third-party service providers who assist us in delivering our platform and services. These service providers are obligated to use your information solely for the purposes specified by us and in compliance with applicable privacy laws.
                </span>
                <span className="font-bold text-white text-md">
                    3.2 Aggregated and Anonymized Data
                </span>
                <span className="font-regular text-white text-md">
                    We may aggregate and anonymize the data collected through our platform to generate statistical insights and industry benchmarks. Such aggregated and anonymized data does not identify you personally and may be shared with third parties for marketing, research, or analytical purposes.
                </span>
                <span className="font-bold text-white text-md">
                    3.3 Compliance with Legal Obligations
                </span>
                <span className="font-regular text-white text-md">
                    We may disclose your information if required to do so by law or in response to valid requests by public authorities (e.g., court orders, government agencies) or to protect our legal rights, interests, or the safety of others.
                </span>
                <span className="font-bold text-white text-md">
                    3.4 Business Transfers
                </span>
                <span className="font-regular text-white text-md">
                    In the event of a merger, acquisition, or sale of our company or assets, your information may be transferred to the acquiring entity as part of the transaction. We will notify you via email or prominent notice on our platform if such a transfer occurs.
                </span>
                <span className="font-bold text-grayText text-lg">
                    4. Data Retention
                </span>
                <span className="font-regular text-white text-md">
                    We will retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by law. We will securely dispose of or anonymize your information once it is no longer needed.
                </span>
                <span className="font-bold text-grayText text-lg">
                    5. Security
                </span>
                <span className="font-regular text-white text-md">
                    We implement reasonable security measures to protect the confidentiality, integrity, and availability of personal information. Keep in mind that no method of transmission or storage is entirely secure, and we cannot guarantee absolute security.
                </span>
                <span className="font-bold text-grayText text-lg">
                    6. Your Rights and Choices
                </span>
                <span className="font-regular text-white text-md">
                    You may have certain rights regarding your personal information, including:
                </span>
                <ul className="list-disc font-regular text-white text-md">
                    <li>Accessing and updating your information: You can access and edit your personal information through your account settings or by contacting us.</li>
                    <li>Opting out of marketing communications: You can unsubscribe from our marketing communications at any time by following the instructions provided in the emails or contacting us directly.</li>
                    <li>Data subject rights: Subject to applicable laws, you may have the right to request the deletion, restriction, or portability of your personal information or object to its processing.</li>
                </ul>
                <span className="font-bold text-grayText text-lg">
                    7. Third-Party Links and Services
                </span>
                <span className="font-regular text-white text-md">
                    Our platform may contain links to third-party websites, services, or applications. We are not responsible for the privacy practices or content of these third parties.
                </span>
                <span className="font-regular text-white text-md">
                    We encourage you to review their privacy policies before providing any personal information.
                </span>
                <span className="font-bold text-grayText text-lg">
                    8. Children's Privacy
                </span>
                <span className="font-regular text-white text-md">
                    Our platform is not intended for children under the age of 16. We do not knowingly collect personal information from individuals under 16 years of age. If you believe we have inadvertently collected information from a child, please contact us, and we will promptly delete it.
                </span>
                <span className="font-bold text-grayText text-lg">
                    9. Changes to this Privacy Policy
                </span>
                <span className="font-regular text-white text-md">
                    We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the updated policy on our platform or by other means. Your continued use of our services after the effective date of the revised Privacy Policy constitutes your acceptance of the changes.
                </span>
                <span className="font-bold text-grayText text-lg">
                    10. Contact Us
                </span>
                <span className="font-regular text-white text-md">
                    If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please <a target="_blank" href="https://www.onxite.com/" className="underline text-neonGreen">contact us</a> using the information below:
                </span>
                <ul className="list-disc font-bold text-white text-md">
                    <li>[Your Company Name]</li>
                    <li>[Address]</li>
                    <li>[Email]</li>
                    <li>[Phone]</li>
                </ul>
                <span className="font-regular text-white text-md">
                    Thank you for taking the time to review our Privacy Policy.
                </span>
                <div className="flex flex-row mt-20">
                    <div className="flex flex-row items-center flex-1">
                        <Link to="/privacypolicy" className="text-white font-regular text-base" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Privacy Policy</Link>
                        <span className="font-regular text-grayText text-sm pl-4">© 2025 Onxite. All rights reserved.</span>
                    </div>
                    <div className="flex flex-row flex-1 justify-end">
                        <img src={iconInsta} className="size-6" />
                        <img src={iconLinke} className="size-6 ml-2" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
